<div *ngIf="isLoggedIn">
    <pivot-header></pivot-header>
    <pivot-sidebar 
        [data]="sidebarData" 
        [isExpanded]="sidebarExpanded" 
        (toggleSidebar)="handleToggleSidebar($event)">
    </pivot-sidebar>
</div>
<router-outlet></router-outlet>